var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"question__container"}},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('div',{attrs:{"id":"point"}},[_vm._v("直感で書いてみよう！")]),_vm._v(" "),_c('div',{attrs:{"id":"question__box"}},[_vm._v("\n    "+_vm._s(_vm.q)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0821d1ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question.vue
// module id = null
// module chunks = 